<ion-item-group>
  <ion-item-divider>
    <ion-label>{{ 'SagaMobile.Itinerary' | translate }}</ion-label>
  </ion-item-divider>

  <app-settings-select-field [entry]="extItineraryProviderListSettings"></app-settings-select-field>
</ion-item-group>
